import React, { useState, useEffect, useContext, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GlobalContext } from "../../../utils/GlobalContext";
import "../../../../css/SingleRingBuilder/SliderImages.css";
import { CONSTANT } from '../../../utils/constants';

const SliderImages = ({
  selectedValue = "",          // currently selected option
  onChange,                    // callback to parent
  labelName = "Select Option", // label above slider
  requestOption = [],          // list of images { src, text }
  textName = "",
}) => {
    const { accessToken } = useContext(GlobalContext);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const sliderRef = useRef(null);
    const [sliderCount] = useState(()=>{
        if(windowWidth > 1200){
            if(textName == 'ring_category'){
                return 4;
            }
            if(textName == 'shape_id'){
                return 5;
            }else{
                return 4;
            }
        }else{
            if(textName == 'shape_id'){
                return 3;
            }else{
                return 3;
            }
        }
    });
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: sliderCount,
        slidesToScroll: 2,
        autoplay: false,
        arrows: true,
        width: "50%",
    };

    // Update slider when screen resizes
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Auto scroll to selected item when selectedValue changes
    useEffect(() => {
        if (sliderRef.current && selectedValue && requestOption.length > 0) {
            const selectedIndex = requestOption.findIndex(
                (item) => {
                    const itemValue = textName === 'ring_category' ? item.item_no : item.text;
                    return itemValue === selectedValue;
                }
            );
            if (selectedIndex !== -1) {
                // Scroll to the selected item
                sliderRef.current.slickGoTo(selectedIndex);
            }
        }
    }, [selectedValue, requestOption, textName]);

    return (
        <div>
        {requestOption.length > 0 ? (
            <>
            {textName == `ring_category` ? (
                <>
                {windowWidth >= 950 && (
                    <div className="slider-title-category" style={{textAlign:`center!important`}}><b>Suggestions To Get You Started</b></div>
                )}
                </>
            ):(
                <div className="slider-title">{labelName}:</div>
            )}
            <Slider ref={sliderRef} {...settings}>
                {requestOption.map((slide, index) => {
                const itemValue = textName === 'ring_category' ? slide.item_no : slide.text;
                const isSelected = selectedValue === itemValue; // compare by text (or id if you have one)
                return (
                    <div
                    key={index}
                    onClick={() => {
                        const itemValue = textName === 'ring_category' ? slide.item_no : slide.text;
                        onChange({ target: { value: itemValue, dataset: { id: slide.id } } });
                    }} // synthetic event
                    className={`shape-item ${
                        isSelected ? "shape-item-selected" : ""
                    }`}
                    >
                        <input
                            type="radio"
                            name={textName}
                            value={slide.text}
                            data-id={slide.id}
                            onChange={() => onChange(slide.text)}
                            className="shape-radio"
                            id={`shape-${slide.text}`}
                            checked={selectedValue === slide.text} // Properly bind checked
                            hidden
                        />
                        {textName == `ring_category` ? (
                            <>
                                <img className={`item-img img-${textName}`} src= {slide.src} alt={slide.item_no} />
                                <p>{slide.item_no}</p>
                            </>
                        ):(
                            <>
                                <img className={`item-img img-${textName}`} src= {CONSTANT.BASE_URL+''+slide.src} alt={slide.text} />
                                <p>{slide.text}</p>
                            </>
                        )}
                    </div>
                );
                })}
            </Slider>
            </>
        ) : (
            <p>No options found</p>
        )}
        </div>
    );
};

export default SliderImages;
